// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import styles from './styles.css.js';
// istanbul ignore next - tested via screenshot tests
export default function VerticalConnector({ variant }) {
    // istanbul ignore next - tested via screenshot tests
    return React.createElement("div", { className: clsx(styles['vertical-connector'], styles[variant]) });
}
//# sourceMappingURL=index.js.map